import script from "./FenPubilsh.vue?vue&type=script&setup=true&lang=js"
export * from "./FenPubilsh.vue?vue&type=script&setup=true&lang=js"

import "./FenPubilsh.vue?vue&type=style&index=0&id=9f92e1a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f92e1a8"]])

export default __exports__